(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Mobile navigation */
  var header = $('[data-header]');
  var toggle = $('[data-nav-toggle]');
  function closeNav() {
    if (!header || !toggle) return;
    header.classList.remove('nav-open');
    toggle.setAttribute('aria-expanded', 'false');
  }
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('nav-open')) { closeNav(); toggle.focus(); }
    });
  }

  /* Collection filters: submit on change */
  var ff = $('[data-filter-form]');
  if (ff) {
    var submitFilters = function () {
      $$('input[type=number]', ff).forEach(function (i) { if (!i.value) i.disabled = true; });
      ff.submit();
    };
    $$('input, select', ff).forEach(function (el) { el.addEventListener('change', submitFilters); });
    var wrap = $('[data-filters-wrap]', ff);
    if (wrap && window.matchMedia('(min-width: 900px)').matches) wrap.open = true;
  }

  /* Cart page: submit when a quantity changes */
  $$('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = $('input', btn.closest('.qty'));
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
  });

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  /* Product page */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root.parentNode) || $('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var inputs = $$('[data-option-input]', root);
    var form = $('form[action*="/cart/add"]', root);
    var idInput = form && $('[name=id]', form);
    var btn = form && $('[data-add]', form);
    var msg = form && $('[data-msg]', form);
    var priceBox = $('[data-price]', root);

    function showMedia(id) {
      if (!id) return;
      var found = false;
      $$('.gallery__slide', root).forEach(function (s) {
        var on = s.getAttribute('data-media-id') === String(id);
        s.classList.toggle('is-active', on);
        if (on) found = true;
      });
      if (!found) return;
      $$('.gallery__thumb', root).forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id));
      });
    }

    $$('.gallery__thumb', root).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });

    function selectedOptions() {
      var out = [];
      $$('.opt', root).forEach(function (fs) {
        var checked = $('input:checked', fs);
        out[parseInt(fs.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
      });
      return out;
    }

    function findVariant() {
      var sel = selectedOptions();
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) { if (variants[i].options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }

    function render(v) {
      if (!btn) return;
      if (!v) {
        btn.disabled = true; btn.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceBox) {
        var now = $('[data-price-now]', priceBox), was = $('[data-price-was]', priceBox);
        if (now) now.textContent = v.price;
        if (was) { was.textContent = v.compare || ''; was.hidden = !v.compare; }
        priceBox.classList.toggle('is-sale', !!v.compare);
      }
      showMedia(v.media);
      if (window.history && history.replaceState) {
        history.replaceState({}, '', location.pathname + '?variant=' + v.id);
      }
    }

    inputs.forEach(function (i) {
      i.addEventListener('change', function () { if (msg) msg.textContent = ''; render(findVariant()); });
    });

    var initial = variants.filter(function (v) { return idInput && String(v.id) === String(idInput.value); })[0];
    if (initial) showMedia(initial.media);

    if (form && btn) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        if (btn.disabled) return;
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…';
        msg.className = 'buy__msg'; msg.textContent = '';
        fetch(window.theme.routes.cartAdd + '.js', {
          method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
        }).then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add this item.');
            return data;
          });
        }).then(function () {
          return fetch(window.theme.routes.cartJs, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        }).then(function (cart) {
          setCartCount(cart.item_count);
          msg.textContent = 'Added to cart. ';
          var a = document.createElement('a');
          a.href = window.theme.routes.cart; a.textContent = 'View cart';
          msg.appendChild(a);
        }).catch(function (err) {
          msg.className = 'buy__msg is-error'; msg.textContent = err.message;
        }).then(function () {
          btn.textContent = label; btn.disabled = false;
        });
      });
    }
  });
})();
